module.exports = __webpack_public_path__ + "static/media/uy.4a7f4ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/uy.png
// module id = 2012
// module chunks = 0